import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { View } from '@dbk/ui-react-utils';
import { List, ListItem } from '@dbk/ui-list';
import { Radio } from '@dbk/ui-forms';
import Text,{H1} from '@dbk/ui-text';
import { FormattedMessage } from '@dbk-legacy/format';
import currencyData from '../../data/currencylist.json';
import ScrollableLayout from '../../components/common/scrollable-layout';

class ProfileCurrencyOptions extends Component {
  async handlePress(currency) {
    const {changePage, i18n: {messages}, config: {regionCode}} = this.props;
    await this.props.currencies.onCurrencyPress({
       currency
    });

    changePage ({ pathname: '/profile' });
    
    if(regionCode !=='CH'){
      alert(messages['app.profile.currency.changeCurrencyMsg']);
    }
    
  }

  renderListItems = (item,index) => {
    const { i18n: { messages }, auth: {
      destinationCurrency,
      settingsDisabled
    } } = this.props;
    const { currency, country, key } = item;
    const selectedCurrency = (!destinationCurrency ? 'default' : destinationCurrency) === key;

    return(
      <ListItem tabIndex={-1} role="none" onClick={() => !settingsDisabled ? this.handlePress(key) : null} className="profile__list-item" id={`listItem_viewCurrency_profileCurrencyOptions_test_${key}_${index}`}>
        <div className='profile__currency-option'>
          <Radio title={currency === 'Default' ? messages['app.profile.currency.default'] : currency} className='profile__radio-button' checked={selectedCurrency}  disabled={settingsDisabled}/>
          <div tabIndex={0} className={currency === 'Default' ? 'profile__currency-option_curr_default': 'profile__currency-option_curr'}>
            <Text className="currency currency__list-item-currency">{
              currency === 'Default' ? messages['app.profile.currency.default'] : currency
            }
            </Text>
            <div>
            <Text className="currency">
            {currency === 'Default' ? <FormattedMessage
                id={country} 
                className="currency"
                values={{ BASE_CCY : this.props.userprofile.baseCurrency}}
                renderProps = {{
                  style: {whiteSpace: 'normal'}
                }}
              /> : messages[country]}
            </Text>
            </div>
          </div>
        </div>
      </ListItem>
    );
  }

  renderCurrencyOptions = (currencyList) => {
    return (
      // <div className="consolidation__items-wrapper">
        <List className="profile__list scrollHeight" fullWidth size="large">
        {
          currencyList.map((item,index) => {
            return this.renderListItems(item,index)
          })
        }
        </List>
      // </div>
    );
  }

  render() {
    const currencyList = currencyData.currencyList;

    const {
     i18n: { messages }
    } = this.props;

    return (
      <div>
      <ScrollableLayout
        testID="Profile-view"
        body={
          <div className="row consolidation">
            <div className="columns small-12 large-12  profile-container">
              <div className="profile-container__title">
                <H1 className="margin-top-1" tabIndex={0} id="text_viewCurrency_profileCurrencyOptions_test">{messages['app.common.pageTitle.viewCurrency']}</H1>
              </div>
              <div>
                  <Text size="big" tabIndex={0}>{messages['app.profile.currencyHead']}</Text>
              </div>
              <div className="settings-list-item profile__content" id="list_viewCurrency_profileCurrencyOptions_test">
                <div>
                  {this.renderCurrencyOptions(currencyList)}
                </div>
              </div>
            </div>            
          </div>         
        }
      />
       </div>
       
    )
  }
}

export default createContainer({
  $queries: {
    auth: {
      destinationCurrency: true,
      settingsDisabled: true
    },
    userprofile: {
      baseCurrency: true
    },
    currencies: {
      onCurrencyPress: { $call: 'saveCurrency' },
    },
    i18n: {
      messages: true
    },
    changePage: { $call: 'ui.history.push' }
  },
})(ProfileCurrencyOptions);
